import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const BLUE_CODE: PaymentMethod = {
    id: PAYMENT_METHOD_ID.BlueCode,
    name: 'bluecode'
};
